var e,
    r = require("react"),
    n = (e = r) && "object" == typeof e && "default" in e ? e.default : e,
    o = r.createContext(null);

exports.Container = function (e) {
  return {
    _id: Symbol(),
    hook: e
  };
}, exports.Provider = function (e) {
  var r = e.children,
      t = e.inject,
      i = {};
  return Array.isArray(t) ? t.forEach(function (e) {
    return i[e._id] = e.hook();
  }) : console.warn("[nonaction] Seems like `inject` in your Provider is not an array?"), n.createElement(o.Provider, {
    value: i
  }, r);
}, exports.useProvided = function (e) {
  return r.useContext(o)[e._id];
};